module.exports = __webpack_public_path__ + "static/media/PlitviceLakes_Croatia_5.4c86c6bb.jpg";